import { zIndex } from "html2canvas/dist/types/css/property-descriptors/z-index";
import React, { useRef, useState, useEffect } from "react";
import { PiMagicWand } from "react-icons/pi";
import { BiFullscreen } from "react-icons/bi";
import "./PdfViewer.css";

interface PdfViewerProps {
  url: string;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ url }) => {
  // Ref for the iframe
  const pdfFrameRef = useRef<HTMLIFrameElement | null>(null);

  // State to track fullscreen mode
  const [isFullscreen, setIsFullscreen] = useState<boolean>(false);

  // Function to open fullscreen
  const openFullscreen = () => {
    const frame = pdfFrameRef.current;
    if (frame) {
      if (frame.requestFullscreen) {
        frame.requestFullscreen();
      } else if ((frame as any).mozRequestFullScreen) {
        (frame as any).mozRequestFullScreen(); // Firefox
      } else if ((frame as any).webkitRequestFullscreen) {
        (frame as any).webkitRequestFullscreen(); // Chrome, Safari, Opera
      } else if ((frame as any).msRequestFullscreen) {
        (frame as any).msRequestFullscreen(); // IE/Edge
      }
      setIsFullscreen(true);
    }
  };

  // Function to exit fullscreen
  const closeFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
    setIsFullscreen(false);
  };

  // Listen for fullscreen changes
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "MSFullscreenChange",
        handleFullscreenChange
      );
    };
  }, []);

  return (
    <div style={{ textAlign: "center", padding: "0px" }}>
      {/* <h2>PDF Preview</h2> */}

      {/* Small iFrame Preview */}
      <div
        id="pdf-container"
        style={{
          width: "200px",
          height: "170px",
          padding: "0px",
          marginLeft: "0px",
          border: "0px solid transparent",
          cursor: "pointer",
          display: "flex",
        }}
        onClick={openFullscreen}
      >
        <iframe
          ref={pdfFrameRef}
          id="pdf-frame"
          src={url}
          width="100%"
          height="100%"
          allowFullScreen
          frameBorder={0}
          title="PDF Preview"
        ></iframe>
      </div>

      <BiFullscreen className="zoom-pdf" size={18} onClick={openFullscreen} />
      {/* Button to Open Fullscreen */}
      <br />

      {/* Close Button When in Fullscreen */}
      {isFullscreen && (
        <button
          onClick={closeFullscreen}
          style={{
            position: "fixed",
            top: "30px",
            right: "30px",
            padding: "10px 15px",
            fontSize: "16px",
            background: "red",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
        >
          Close Fullscreen
        </button>
      )}
    </div>
  );
};

export default PdfViewer;
